<template>
  <div class="database-container">
    <a-card class="content-card">
      <div class="page-header">
        <div class="header-icon">
          <a-icon type="api" />
        </div>
        <div class="header-text">
          <h2 class="page-title">{{ translate('proxy_test') }}</h2>
          <p class="page-description">{{ translate('proxy_test_description') }}</p>
        </div>
      </div>
      <div class="proxy-content">
        <div class="proxy_wrap_top">
          <div class="proxy_left">
            <div class="info-card">
              <p class="info-title">{{ translate('instructions') }}：</p>
              <p>1. {{ translate('proxy_instruction_1') }}</p>
              <p>2. {{ translate('proxy_instruction_2') }}</p>
              <p>3. {{ translate('proxy_instruction_3') }}</p>
              <p style="font-size: 12px;">{{ translate('supported_format') }}：</p>
              <p style="font-size: 12px;color: #1e4dff">192.168.0.1:8000:{{ translate('proxy_account') }}:{{ translate('proxy_password') }}</p>
            </div>
          </div>
          <div class="proxy_right">
            <a-form :model="form" ref="form" layout="vertical" class="form-container">
              <a-form-item :label="translate('ip_query_channel')">
                <a-select v-model="form.ipQueryChannel" :placeholder="translate('please_select')">
                  <a-select-option
                    v-for="item in ipQueryChannels"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :label="translate('proxy_type')">
                <a-select v-model="form.proxyType" :placeholder="translate('please_select')">
                  <a-select-option
                    v-for="item in proxyTypes"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :label="translate('proxy_info')">
                <a-textarea
                  v-model="form.proxyInfo"
                  @change="onChange"
                  :placeholder="translate('please_input_content')"
                  :rows="4"
                />
              </a-form-item>
            </a-form>
          </div>
        </div>
        <div class="checkProxy">
          <a-button type="primary" class="action-btn" @click="checkProxy">
            {{ translate('check_proxy') }}
          </a-button>
        </div>
        <a-table
          :columns="columns"
          :data-source="proxyList"
          :row-key="(record, index) => `${record.ip}:${record.port}:${index}`"
          :pagination="false"
          class="proxy-table"
        >
          <template slot="status" slot-scope="cell, record">
            <template v-if="record">
              <div v-if="record.loading">
                <a-spin size="small" />
              </div>
              <div v-else>
                {{ record.status }}
              </div>
            </template>
          </template>
        </a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  inject: ['languageState'],
  data() {
    // 使用默认语言初始化，避免computed-in-data问题
    const langTranslations = {
      en: {
        proxy_test: 'Proxy Test',
        proxy_test_description: 'Please fill in the proxy information and click the Check Proxy button to test proxy availability',
        instructions: 'Instructions',
        proxy_instruction_1: 'If proxy type is not filled in, it will be added according to the set proxy type',
        proxy_instruction_2: 'Only HTTP and Socks5 proxy types are supported',
        proxy_instruction_3: 'One proxy per line, up to 20 at a time',
        supported_format: 'Supported format',
        proxy_account: 'proxy_account',
        proxy_password: 'proxy_password',
        ip_query_channel: 'IP Query Channel',
        proxy_type: 'Proxy Type',
        proxy_info: 'Proxy Information',
        check_proxy: 'Check Proxy',
        please_select: 'Please select',
        please_input_content: 'Please input content',
        proxy_type_col: 'Proxy Type',
        proxy_host_col: 'Proxy Host',
        proxy_port_col: 'Proxy Port',
        proxy_account_col: 'Proxy Account',
        proxy_password_col: 'Proxy Password',
        ip_channel_col: 'IP Channel',
        exit_ip_col: 'Exit IP',
        status_col: 'Status',
        unchecked: 'Unchecked',
        checking: 'Checking',
        available: 'Available',
        unavailable: 'Unavailable',
        check_failed: 'Check Failed'
      },
      zh: {
        proxy_test: '代理测试',
        proxy_test_description: '请填写代理信息，点击检查代理按钮测试代理可用性',
        instructions: '说明',
        proxy_instruction_1: '不填写代理类型时，将按照设置的代理类型进行添加',
        proxy_instruction_2: '代理类型仅支持HTTP、Socks5',
        proxy_instruction_3: '一行一个代理，一次最多添加20个',
        supported_format: '支持以下填写格式',
        proxy_account: '代理账号',
        proxy_password: '代理密码',
        ip_query_channel: 'IP查询渠道',
        proxy_type: '代理类型',
        proxy_info: '代理信息',
        check_proxy: '检查代理',
        please_select: '请选择',
        please_input_content: '请输入内容',
        proxy_type_col: '代理类型',
        proxy_host_col: '代理主机',
        proxy_port_col: '代理端口',
        proxy_account_col: '代理账号',
        proxy_password_col: '代理密码',
        ip_channel_col: 'IP查询渠道',
        exit_ip_col: '出口IP',
        status_col: '状态',
        unchecked: '未检查',
        checking: '正在检查',
        available: '可用',
        unavailable: '不可用',
        check_failed: '检查失败'
      }
    };
    return {
      form: {
        ipQueryChannel: 'IPinfo',
        proxyType: 'Socks5',
        proxyInfo: ''
      },
      langTranslations,
      proxyList: [],
      ipQueryChannels: [
        { value: 'IPinfo', label: 'IPinfo' }
      ],
      proxyTypes: [
        { value: 'Socks5', label: 'Socks5' },
        { value: 'HTTP', label: 'HTTP' }
      ],
      loading: false
    };
  },
  computed: {
    currentLanguage() {
      return this.languageState?.languageCode || 'en';
    },
    columns() {
      return [
        { title: this.translate('proxy_type_col'), dataIndex: 'proxytype', key: 'proxytype', width: 100 },
        { title: this.translate('proxy_host_col'), dataIndex: 'ip', key: 'ip', width: 100 },
        { title: this.translate('proxy_port_col'), dataIndex: 'port', key: 'port', width: 100 },
        { title: this.translate('proxy_account_col'), dataIndex: 'account', key: 'account', width: 100 },
        { title: this.translate('proxy_password_col'), dataIndex: 'password', key: 'password', width: 100 },
        { title: this.translate('ip_channel_col'), dataIndex: 'ipchanel', key: 'ipchanel', width: 100 },
        { title: this.translate('exit_ip_col'), dataIndex: 'ipout', key: 'ipout', width: 100 },
        { title: this.translate('status_col'), dataIndex: 'status', key: 'status', width: 100, scopedSlots: { customRender: 'status' } }
      ];
    }
  },
  watch: {
    'form.proxyType': function(newType) {
      this.proxyList.forEach(proxy => {
        this.$set(proxy, 'proxytype', newType);
      });
    }
  },
  methods: {
    translate(key) {
      const lang = this.currentLanguage;
      return this.langTranslations[lang][key] || key;
    },
    parseProxyString(str) {
      const parts = str.split(':');
      const host = parts[0];
      const port = parts[1];
      const account = parts[2] || '';
      const password = parts[3] || '';

      return {
        proxytype: this.form.proxyType,
        ip: host,
        port: port,
        account: account || '-',
        password: password || '-',
        ipchanel: this.form.ipQueryChannel,
        ipout: '-',
        status: this.translate('unchecked'),
        loading: false
      };
    },
    onChange(e) {
      const value = e.target.value;
      const lines = value.split('\n').filter(line => line.trim() !== '');
      this.proxyList = lines.map(this.parseProxyString).slice(0, 20);
    },
    async checkProxy() {
      for (let i = 0; i < this.proxyList.length; i++) {
        const proxy = this.proxyList[i];
        this.$set(proxy, 'loading', true);
        this.$set(proxy, 'status', this.translate('checking'));
        try {
          const res = await this.$request.post("/checkproxy/check", {
            proxyPort: proxy.port,
            proxyHost: proxy.ip,
            username: proxy.account,
            password: proxy.password,
            proxytype: proxy.proxytype
          });
          if (res.data.code === 200) {
            this.$set(proxy, 'status', this.translate('available'));
            const eachData = JSON.parse(res.data.data);
            this.$set(proxy, 'ipout', `${eachData.ip}\n${eachData.country_code}\n${eachData.country_name}`);
          } else {
            this.$set(proxy, 'status', this.translate('unavailable'));
          }
        } catch (error) {
          console.error('检查代理失败', error);
          this.$set(proxy, 'status', this.translate('check_failed'));
        } finally {
          this.$set(proxy, 'loading', false);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.database-container {
  padding: 24px;
  background: linear-gradient(180deg, #f0f5ff 0%, #f5f5f5 100%);
  min-height: 100%;
}

.content-card {
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: #fff;
  border: 1px solid #e8e8e8;
  padding: 0;
  overflow: hidden;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 28px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0;
  border-bottom: none;
}

.header-icon {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .anticon {
    font-size: 28px;
    color: #fff;
  }
}

.header-text {
  flex: 1;
}

.page-title {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px 0;
  letter-spacing: 0.5px;
}

.page-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  line-height: 1.6;
}

.proxy-content {
  padding: 32px;
}

.proxy_wrap_top {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 24px;
  margin-bottom: 24px;
}

.proxy_left {
  width: 28%;
  flex-shrink: 0;
}

.proxy_right {
  flex: 1;
  min-width: 0;
}

.info-card {
  background: #f4f6ff;
  padding: 24px;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  
  p {
    margin-bottom: 12px;
    color: #333;
    font-size: 15px;
    line-height: 1.7;
  }
  
  p:last-child {
    margin-bottom: 0;
  }
  
  .info-title {
    font-weight: 600;
    color: #262626;
    font-size: 16px;
  }
}

.form-container {
  padding: 28px;
  background: #fff;
  border-radius: 18px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

:deep(.ant-form-item-label) {
  text-align: left !important;
  margin-bottom: 8px;
}

:deep(.ant-form-item-label > label) {
  font-size: 15px;
  font-weight: 600;
  color: #434343;
  padding: 0 !important;
  margin-right: 0;
}

:deep(.ant-select-selector),
:deep(.ant-input) {
  border-radius: 12px !important;
  border-color: #d9d9d9 !important;
  height: 48px !important;
  font-size: 15px !important;
  
  &:focus,
  &:hover {
    border-color: #667eea !important;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;
  }
}

:deep(.ant-input-textarea) {
  height: auto !important;
  min-height: 120px;
  font-size: 15px !important;
  border-radius: 12px !important;
  border-color: #d9d9d9 !important;
  overflow: visible !important;
  
  &:focus,
  &:hover {
    border-color: #667eea !important;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;
  }
}

/* 最直接的方式，使用 :deep() 穿透选择器确保样式应用到原生 textarea */
:deep(textarea.ant-input) {
  resize: vertical !important;
  min-height: 120px !important;
  max-height: none !important;
  height: auto !important;
  overflow: auto !important;
  font-size: 15px !important;
  box-sizing: border-box !important;
  display: block !important;
  width: 100% !important;
  border-radius: 12px !important;
  border-color: #d9d9d9 !important;
  line-height: 1.5 !important;
  padding: 8px 12px !important;
}

/* 确保父容器不限制高度 */
:deep(.ant-input-textarea),
:deep(.ant-input-textarea-wrap) {
  overflow: visible !important;
  height: auto !important;
  min-height: 120px !important;
  max-height: none !important;
}

/* 移除所有可能限制 resize 的样式 */
:deep(.ant-input-textarea) {
  resize: vertical !important;
}

:deep(.ant-input-textarea-wrap) {
  resize: vertical !important;
}

.checkProxy {
  margin: 24px 0;
  text-align: center;
  
  .action-btn {
    height: 44px;
    font-size: 14px;
    font-weight: 600;
    padding: 0 32px;
    border-radius: 10px !important;
    line-height: 44px !important;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
      background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;
    }
    
    &:active {
      transform: translateY(0);
    }
  }
}

.proxy-table {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  
  :deep(.ant-table-thead > tr > th) {
    background-color: #f4f6ff;
    color: #333;
    font-weight: 600;
    font-size: 13px;
    padding: 16px;
  }
  
  :deep(.ant-table-tbody > tr > td) {
    color: #666;
    font-size: 13px;
    padding: 16px;
    
    &:hover {
      background-color: #f7f8fa;
    }
  }
  
  :deep(.ant-table-row) {
    transition: background-color 0.3s ease;
  }
}

@media (max-width: 768px) {
  .database-container {
    padding: 16px;
  }
  
  .page-header {
    padding: 20px 24px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .header-icon {
    width: 48px;
    height: 48px;
    
    .anticon {
      font-size: 24px;
    }
  }
  
  .page-title {
    font-size: 22px;
  }
  
  .proxy-content {
    padding: 20px;
  }
  
  .proxy_wrap_top {
    flex-direction: column;
    gap: 16px;
  }
  
  .proxy_left,
  .proxy_right {
    width: 100%;
  }
  
  .checkProxy .action-btn {
    width: 100%;
  }
}
</style>